import React, { useEffect, useState } from "react";
import "./index.css";
import CountdownTimer from "../../../node_modules/react-component-countdown-timer";
import Bottom from "./Bottom";
import { useHistory, useParams } from "react-router-dom";
// import {setNewPaper} from "./getSetters.js"
import { useDispatch, useSelector } from "react-redux";
import {
  setQuestions,
  getQuestions,
  setTitle,
  setCompletedPapers,
  getCompletedPapers,
} from "../../features/Questions/questionSlice";
import { db } from "../firebase";
// import { Button } from "@material-ui/core";
import firebase from "./../firebase";
import { getTitle } from "./../../features/Questions/questionSlice";

function TestPage() {
  // let location = useLocation();
  const Questions = useSelector(getQuestions);
  let maxQ = Questions.length;
  const dispatch = useDispatch();
  // const occupiedPapers = useSelector(getOccupiedTopics) || [];
  const d = new Date();
  const [startTime, setstartTime] = useState(0);
  let history = useHistory();
  let { id } = useParams();
  const completedPapers = useSelector(getCompletedPapers);
  const [startedTest, setstartedTest] = useState(false);
  dispatch(setTitle(atob(id)));
  const titleOfPaper = useSelector(getTitle);

  const updateAnswers = async () => {
    firebase.auth().onAuthStateChanged(function (user) {
      let jsonTemp = {};
      jsonTemp[atob(id)] = Questions;
      // console.log(jsonTemp);
      const docRef = db.collection("Answers").doc(user.email);
      docRef
        .set(jsonTemp, { merge: true })
        .then(
          db
            .collection("user-details")
            .doc(user.email)
            .update({
              Answers: firebase.firestore.FieldValue.arrayUnion(titleOfPaper),
            })
        )
        .catch((err) => console.error(err));
    });
  };

  const PaperEnd = () => {
    alert("paper has ended");
    updateAnswers();
    dispatch(setCompletedPapers([...completedPapers,atob(id)]));
    // console.log(completedPapers);
    history.push("/result/" + id);
  };

  const Timer = () => {
    return (
      <>
        <CountdownTimer
          count={(10800 + (startTime - d.getTime()) / 1000) | 0}
          size={25}
          hideDay
          color="white"
          backgroundColor="inherit"
          onEnd={() => {
            PaperEnd();
          }}
        />
      </>
    );
  };
  const fetchQuestions = async (id) => {
    const docRef = db.collection("Papers").doc(id);
    return docRef
      .get()
      .then((data) => data.exists && data.data())
      .then((data) => data.data)
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    // setNewPaper();
    async function someFunction(){
    // let paperExists;
    // firebase.auth().onAuthStateChanged(function (user) {
    //   const ref = db.collection("Answers").doc(user.email);
    //   // console.log("searching here");
    //   ref
    //     .get()
    //     .then((data) => data.exists && data.data())
    //     .then((data) => data[titleOfPaper])
    //     .then((data) => {
    //       // console.log("still searching...");
    //       if (data) {
    //         dispatch(setQuestions(data));
    //         paperExists = true;
    //         // console.log("found");
    //       }
    //     })
    //     .catch((err) => console.error(err));
    // });
    // if (!paperExists) {
      let data = await fetchQuestions(id);
      try {
        if (data) {
          for (let i = 0; i < data.length; i++) {
            data[i].id = i + 1;
            data[i].time = 0;
            data[i].type = "unvisited";
            data[i].attempted = "";
          }
          data[0].type = "unanswered";
          dispatch(setQuestions(data));
        } else history.push("/error");
      } catch (err) {
        console.error(err);
      }
    // }
    window.alert("test is Starting...");
    setstartTime(d.getTime());
    setstartedTest(true);

    // dispatch(decrementQuestion());
    }
    someFunction();
  }, []);

  return (
    <div className="temp-testPage" style={{ minHeight: "500px" }}>
      <div className="testpage">
        <div className="secondaryHeader">
          <>
            <h2 className="ml-2">MOCK TEST</h2>
          </>
          <div className="timer">{startedTest ? <Timer /> : <p>03 : 00 :00</p>}</div>
        </div>
        {maxQ ? (
        <Bottom PaperEnd={PaperEnd} />) : (<div class="lds-dual-ring"></div>)}
        {/* <Button onClick = {() => {setNewPaper()}} >Set Sub</Button> */}
      </div>
    </div>
  );
}

export default TestPage;
